import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { usePartnerUIContext } from "../PartnerUIContext";
import { PartnerEditDialogHeader } from "./PartnerEditDialogHeader";
import { PartnerEditForm } from "./PartnerEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/partnerAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";

export const PartnerEditDialog = ({ id, show, onHide }) => {
  // Partner UI Context
  const partnerUIContext = usePartnerUIContext();
  const partnerUIProps = useMemo(() => {
    return {
      initPartner: partnerUIContext.initPartner,
      queryParams: partnerUIContext.queryParams,
      setQueryParams: partnerUIContext.setQueryParams,
    };
  }, [partnerUIContext]);

  // Partner Redux state
  const dispatch = useDispatch();
  const { actionsLoading, partnerForEdit, error, roleMaster } = useSelector(
    (state) => ({
      actionsLoading: state.partner.actionsLoading,
      partnerForEdit: state.partner.partnerForEdit,
      roleMaster: state.partner.roleMaster,
      error: state.partner.error,
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }
  useEffect(() => {
    // server call for getting Partner by id
    dispatch(actions.fetchPartner(id));
  }, [id, dispatch]);

  const savePartner = (partner) => {
    if (!id) {
      dispatch(actions.createPartner(partner)).then((response) => {
        if (response) toast.success(response.message, toastOption);
        dispatch(actions.fetchPartners(partnerUIProps.queryParams)).then(() =>
          onHide()
        );
      });
    } else {
      dispatch(actions.updatePartner(partner)).then((response) => {
        if (response) toast.success(response.message, toastOption);
        dispatch(actions.fetchPartners(partnerUIProps.queryParams)).then(() =>
          onHide()
        );
      });
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="modal-sizes-title-lg"
      size="lg"
    >
      <PartnerEditDialogHeader id={id} />
      <PartnerEditForm
        savePartner={savePartner}
        actionsLoading={actionsLoading}
        partner={partnerForEdit || partnerUIProps.initPartner}
        onHide={onHide}
        roleMaster={roleMaster}
        id={id}
      />
    </Modal>
  );
};
